<template>
    <v-container fluid class="px-0 py-0">
        <div v-if="exportUrl" style="text-align:right"><a :href="exportUrl" target="_blank"
                style="text-decoration: none;">导出</a></div>
        <v-tabs v-model="active">
            <v-tab v-for="tab in tabs" :key="tab.label">{{ tab.label }}</v-tab>
            <v-tab-item v-for="tab in tabs" :key="tab.label">
                <div>
                    <v-data-table :headers="tab.headers" :items="tab.items" :rows-per-page-items="[20, 50, 100, { text: '全部', value: -1 }]">
                        <template v-slot:items="props">
                            <td v-for="h in tab.headers" :key="h.value">{{ props.item[h.value] }}</td>
                        </template>
                    </v-data-table>
                </div>
            </v-tab-item>
        </v-tabs>
    </v-container>
</template>
<script>
export default {
    name: "clazz-unfinished-stu",
    props: {
        cfg: Object
    },
    data() {
        return {
            tabs: [],
            active: 0,
            exportUrl: null
        };
    },
    watch: {
        cfg() {
            this.init();
        }
    },
    methods: {
        init() {
            let self = this, cfg = self.cfg;
            if (!cfg || !cfg.clazzId) return;

            self.$axios.get(`/home/admin/my/tenant/clazz/stu/unfinished/${cfg.clazzId}`).then(r => {
                if (r.data.status != 'ok') {
                    self.$status(r.data.message || '获取未完成名单失败', 'error');
                    return;
                }
                function toTableData(data, tab) {
                    let hd = data[0], header = [];
                    for (let l of hd) {
                        header.push({ text: l, value: l });
                    }
                    tab.headers = header;

                    let d = data.slice(1), ld = [];
                    for (let l of d) {
                        let tmp = {};
                        ld.push(tmp);
                        for (let i in hd) {
                            tmp[hd[i]] = l[i];
                        }
                    }

                    tab.items = ld;
                }
                self.exportUrl = `${self.$const.baseUrl}/home/admin/my/tenant/clazz/stu/export/unfinisheds/${cfg.clazzId}`;
                let data = r.data.message, tabs = [];
                let d = data[1];
                if (d) {
                    let tab = { label: `未学习名单(${d.length - 1})`, desc: '自开课以来从未进入课程学习的人员' };
                    tabs.push(tab);
                    toTableData(d, tab);
                }
                d = data[3];
                if (d) {
                    let tab = { label: `未完成名单(${d.length - 1})`, desc: '已选课但未完成学习的人员' };
                    tabs.push(tab);
                    toTableData(d, tab);
                }
                d = data[2];
                if (d) {
                    let tab = { label: `未签字名单(${d.length - 1})`, desc: '已完成学习但还未签字的人员' };
                    tabs.push(tab);
                    toTableData(d, tab);
                }
                self.tabs = tabs;
            })
        }
    },
    created() {
        this.init();
    }
}
</script>